import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 scroll-mt-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-3">真实反馈</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">读者评价</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">来自古古漫画网真实读者的使用感受</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {comments.map((comment) => (
            <div key={comment.id} className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }} />
                </div>
                <div>
                  <div className="font-semibold text-sm text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-secondary-600">
                <i className="ri-bookmark-line"></i>
                <span>{comment.comic}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}